import React, { Component } from 'react';
import { Switch } from 'react-router-dom';

import { connect } from 'react-redux';

import { isEmpty } from 'lodash';
import queryString from 'query-string';

import ProtectedRoute from '../../components/ProtectedRoute';

import BobLoadingMask from '../../components/BobLoadingMask';
import ConversionPage from './ConversionPage';
import InformationPage from './InformationPage';
import TechnicianPage from './TechnicianPage';
import ServiceCallStatusMappingPage from './ServiceCallStatusMappingPage';
import WizardPage from './Wizard/WizardPage';

import * as ArchitectActions from '../../actions/architectActions';
import * as BasAgentActions from '../../actions/basAgentActions';
import * as ErpAgentActions from '../../actions/erpAgentActions';

import classes from './Architect.module.css';

class Architect extends Component {
    componentDidMount() {
        const queryValues = queryString.parse(this.props.history.location.search);

        if (isEmpty(this.props.basAgents)) {
            this.props.fetchBasAgents(queryValues.company);
        }

        if (process.env.erpAgentEnabled && isEmpty(this.props.erpAgents)) {
            this.props.fetchErpAgents(queryValues.company);
        }

        this.props.fetchServiceCallStatuses();
        this.props.fetchServiceAppointmentStatuses();
    }

    render() {
        let { currentScopes } = this.props;

        if (!currentScopes) {
            return null;
        }

        return (
            <div className={classes.Architect}>
                <Switch>
                    <ProtectedRoute
                        component={WizardPage}
                        path="/architect/wizard"
                        permissions="architectFull"
                    />
                    <ProtectedRoute
                        component={ConversionPage}
                        path="/architect/conversion/"
                        permissions="architectRead"
                    />
                    {
                        process.env.technicianEnabled &&
                        <ProtectedRoute
                            component={TechnicianPage}
                            path="/architect/technician"
                            permissions="architectRead"
                        />
                    }
                    {
                        process.env.erpAgentEnabled &&
                        <ProtectedRoute
                            component={ServiceCallStatusMappingPage}
                            path="/architect/servicecallstatuses"
                            permissions="architectRead"
                        />
                    }
                    <ProtectedRoute
                        component={InformationPage}
                        path="/architect/"
                        permissions="architectRead"
                    />
                </Switch>
                {
                    this.props.progressBarLoading ?
                        <BobLoadingMask />
                        :
                        null
                }
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        currentScopes:      state.core.currentScopes,
        erpAgents:          Object.values(state.erpAgent.erpAgents),
        progressBarLoading: state.core.progressBarLoading,
    };
};

const mapDispatchToProps = {
    ...ArchitectActions,
    ...BasAgentActions,
    ...ErpAgentActions
};

export default connect(mapStateToProps, mapDispatchToProps)(Architect);
